import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לקרוא לזה בשם",
    opening: localizedGenderNode(
      [
      "היום אני מפסיק/ה לחשוב ש״משהו דפוק בי״ וקורא/ת לזה: תחושת כישלון."
    ],
      [
      "היום אני מפסיק/ה לחשוב ש״משהו דפוק בי״ וקורא/ת לזה: תחושת כישלון."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת איטית.",
      "בלב: “זו תחושה. לא גזר דין.”"
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת איטית.",
      "בלב: “זו תחושה. לא גזר דין.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. איפה בחיים שלי תחושת כישלון חוזרת שוב ושוב?\n[כאן אני כותב]",
      "2. איזה סיפור אני מספר/ת לעצמי על זה?\n[כאן אני כותב]",
      "3. איך הגוף שלי מרגיש כשאני חושב/ת “נכשלתי”?\n[כאן אני כותב]"
    ],
      [
      "1. איפה בחיים שלי תחושת כישלון חוזרת שוב ושוב?\n[כאן אני כותב]",
      "2. איזה סיפור אני מספר/ת לעצמי על זה?\n[כאן אני כותב]",
      "3. איך הגוף שלי מרגיש כשאני חושב/ת “נכשלתי”?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "להרגיש כישלון זה לא להיות כישלון."
    ],
      [
      "סגירה",
      "להרגיש כישלון זה לא להיות כישלון."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום: נשימה + “זו תחושה, לא זהות.”",
      "פעם אחת היום: נשימה + “זו תחושה, לא זהות.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "עובדות מול מסקנות",
    opening: localizedGenderNode(
      [
      "היום אני מפריד/ה בין מה שקרה לבין מה שאני אומר/ת שזה אומר עליי."
    ],
      [
      "היום אני מפריד/ה בין מה שקרה לבין מה שאני אומר/ת שזה אומר עליי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת."
    ],
      [
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מה העובדה היבשה? (בלי פרשנות)\n[כאן אני כותב]",
      "2. איזו מסקנה קשה קפצה מיד?\n[כאן אני כותב]",
      "3. איזו פרשנות עדינה יותר אפשרית?\n[כאן אני כותב]"
    ],
      [
      "1. מה העובדה היבשה? (בלי פרשנות)\n[כאן אני כותב]",
      "2. איזו מסקנה קשה קפצה מיד?\n[כאן אני כותב]",
      "3. איזו פרשנות עדינה יותר אפשרית?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "מסקנה היא לא עובדה."
    ],
      [
      "סגירה",
      "מסקנה היא לא עובדה."
    ]
    ),
    action: localizedGenderNode(
      "“עובדה ≠ זהות.”",
      "“עובדה ≠ זהות.”"
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "הקול שמודד אותי",
    opening: localizedGenderNode(
      [
      "היום אני מזהה את הקול שמודד הצלחה וכישלון."
    ],
      [
      "היום אני מזהה את הקול שמודד הצלחה וכישלון."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה."
    ],
      [
      "נשימה."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. איך הקול הזה מדבר אליי?\n[כאן אני כותב]",
      "2. מאיפה הוא למד למדוד ככה?\n[כאן אני כותב]",
      "3. איזה טון אחר הייתי רוצה?\n[כאן אני כותב]"
    ],
      [
      "1. איך הקול הזה מדבר אליי?\n[כאן אני כותב]",
      "2. מאיפה הוא למד למדוד ככה?\n[כאן אני כותב]",
      "3. איזה טון אחר הייתי רוצה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני לא רוצה/ת להאמין לקול שמקטין אותי."
    ],
      [
      "סגירה",
      "אני לא רוצה/ת להאמין לקול שמקטין אותי."
    ]
    ),
    action: localizedGenderNode(
      "כשעולה המדידה — “שמעתי.”",
      "כשעולה המדידה — “שמעתי.”"
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "כישלון כאירוע, לא זהות",
    opening: localizedGenderNode(
      [
      "היום אני מפריד/ה בין מה שקרה לבין מי שאני."
    ],
      [
      "היום אני מפריד/ה בין מה שקרה לבין מי שאני."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה."
    ],
      [
      "נשימה."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. איזה “כישלון” אני נושא/ת שנים?\n[כאן אני כותב]",
      "2. מה הוא אומר על הניסיון שלי — ולא על הערך שלי?\n[כאן אני כותב]",
      "3. מה למדתי ממנו בפועל?\n[כאן אני כותב]"
    ],
      [
      "1. איזה “כישלון” אני נושא/ת שנים?\n[כאן אני כותב]",
      "2. מה הוא אומר על הניסיון שלי — ולא על הערך שלי?\n[כאן אני כותב]",
      "3. מה למדתי ממנו בפועל?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אירועים קורים. אני נשאר/ת."
    ],
      [
      "סגירה",
      "אירועים קורים. אני נשאר/ת."
    ]
    ),
    action: localizedGenderNode(
      "משפט: “זה קרה — ואני עדיין כאן.”",
      "משפט: “זה קרה — ואני עדיין כאן.”"
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "השוואה שמזינה כישלון",
    opening: localizedGenderNode(
      [
      "היום אני רואה איך השוואה מחזקת את תחושת הכישלון."
    ],
      [
      "היום אני רואה איך השוואה מחזקת את תחושת הכישלון."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה."
    ],
      [
      "נשימה."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. למי אני משווה את עצמי?\n[כאן אני כותב]",
      "2. מה אני לא רואה בסיפור שלו/ה?\n[כאן אני כותב]",
      "3. מה כן מתקיים אצלי — גם אם שקט?\n[כאן אני כותב]"
    ],
      [
      "1. למי אני משווה את עצמי?\n[כאן אני כותב]",
      "2. מה אני לא רואה בסיפור שלו/ה?\n[כאן אני כותב]",
      "3. מה כן מתקיים אצלי — גם אם שקט?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "השוואה מוחקת הקשר."
    ],
      [
      "סגירה",
      "השוואה מוחקת הקשר."
    ]
    ),
    action: localizedGenderNode(
      "עצירת השוואה אחת היום.",
      "עצירת השוואה אחת היום."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "גוף וכישלון",
    opening: localizedGenderNode(
      [
      "היום אני מקשיב/ה לגוף, לא רק למחשבות."
    ],
      [
      "היום אני מקשיב/ה לגוף, לא רק למחשבות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה איטית."
    ],
      [
      "נשימה איטית."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. איפה הכישלון יושב בגוף?\n[כאן אני כותב]",
      "2. מה הגוף בוחר/ת עכשיו?\n[כאן אני כותב]",
      "3. איזו הקלה קטנה אפשרית?\n[כאן אני כותב]"
    ],
      [
      "1. איפה הכישלון יושב בגוף?\n[כאן אני כותב]",
      "2. מה הגוף בוחר/ת עכשיו?\n[כאן אני כותב]",
      "3. איזו הקלה קטנה אפשרית?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "הגוף מבקש הקשבה, לא ביקורת."
    ],
      [
      "סגירה",
      "הגוף מבקש הקשבה, לא ביקורת."
    ]
    ),
    action: localizedGenderNode(
      "יד על חזה/בטן + נשימה.",
      "יד על חזה/בטן + נשימה."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "הצלחה קטנה שלא ספרתי",
    opening: localizedGenderNode(
      [
      "היום אני רואה הצלחות שלא קיבלו כותרת."
    ],
      [
      "היום אני רואה הצלחות שלא קיבלו כותרת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה."
    ],
      [
      "נשימה."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. שלושה דברים שעשיתי למרות הקושי:\n[כאן אני כותב]",
      "2. למה אני נוטה לבטל אותם?\n[כאן אני כותב]",
      "3. איך זה מרגיש להכיר בהם?\n[כאן אני כותב]"
    ],
      [
      "1. שלושה דברים שעשיתי למרות הקושי:\n[כאן אני כותב]",
      "2. למה אני נוטה לבטל אותם?\n[כאן אני כותב]",
      "3. איך זה מרגיש להכיר בהם?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "התקדמות לא תמיד עושה רעש."
    ],
      [
      "סגירה",
      "התקדמות לא תמיד עושה רעש."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב הצלחה אחת ביומן.",
      "לכתוב הצלחה אחת ביומן."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "לשאת כישלון בלי לברוח",
    opening: localizedGenderNode(
      [
      "היום אני נותן/ת לתחושה להיות דקה אחת."
    ],
      [
      "היום אני נותן/ת לתחושה להיות דקה אחת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה."
    ],
      [
      "נשימה."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מה הטריגר שמעלה כישלון?\n[כאן אני כותב]",
      "2. תרגול דקה: אני נשאר/ת — בלי לתקן.\nמה קרה?\n[כאן אני כותב]",
      "3. מה קורה בגוף אחרי הדקה הזו?\n[כאן אני כותב]"
    ],
      [
      "1. מה הטריגר שמעלה כישלון?\n[כאן אני כותב]",
      "2. תרגול דקה: אני נשאר/ת — בלי לתקן.\nמה קרה?\n[כאן אני כותב]",
      "3. מה קורה בגוף אחרי הדקה הזו?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "גל עולה ויורד."
    ],
      [
      "סגירה",
      "גל עולה ויורד."
    ]
    ),
    action: localizedGenderNode(
      "דקה אחת בלבד.",
      "דקה אחת בלבד."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "אחריות בלי הצלפה",
    opening: localizedGenderNode(
      [
      "היום אני לוקח/ת אחריות בלי להעניש."
    ],
      [
      "היום אני לוקח/ת אחריות בלי להעניש."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה."
    ],
      [
      "נשימה."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. על מה כן באחריותי?\n[כאן אני כותב]",
      "2. על מה לא?\n[כאן אני כותב]",
      "3. איך נראית אחריות עם חמלה?\n[כאן אני כותב]"
    ],
      [
      "1. על מה כן באחריותי?\n[כאן אני כותב]",
      "2. על מה לא?\n[כאן אני כותב]",
      "3. איך נראית אחריות עם חמלה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אחריות בונה, לא שוברת."
    ],
      [
      "סגירה",
      "אחריות בונה, לא שוברת."
    ]
    ),
    action: localizedGenderNode(
      "משפט רך לעצמי.",
      "משפט רך לעצמי."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "כישלון ופחד",
    opening: localizedGenderNode(
      [
      "היום אני מזהה את הפחד שמתחת לכישלון."
    ],
      [
      "היום אני מזהה את הפחד שמתחת לכישלון."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה."
    ],
      [
      "נשימה."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מה אני מפחד/ת שזה אומר עליי?\n[כאן אני כותב]",
      "2. מה האיום האמיתי?\n[כאן אני כותב]",
      "3. איזו אמת מרגיעה קיימת?\n[כאן אני כותב]"
    ],
      [
      "1. מה אני מפחד/ת שזה אומר עליי?\n[כאן אני כותב]",
      "2. מה האיום האמיתי?\n[כאן אני כותב]",
      "3. איזו אמת מרגיעה קיימת?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "פחד מדבר בקול חזק."
    ],
      [
      "סגירה",
      "פחד מדבר בקול חזק."
    ]
    ),
    action: localizedGenderNode(
      "נשימה + אמת מרגיעה.",
      "נשימה + אמת מרגיעה."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "ערך עצמי שלא תלוי תוצאה",
    opening: localizedGenderNode(
      [
      "היום אני נפרד/ת בין תוצאה לערך."
    ],
      [
      "היום אני נפרד/ת בין תוצאה לערך."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה."
    ],
      [
      "נשימה."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. איפה אני קושר/ת ערך לתוצאה?\n[כאן אני כותב]",
      "2. איזו תכונה בי קיימת בלי קשר להצלחה?\n[כאן אני כותב]",
      "3. איך מרגיש להפריד?\n[כאן אני כותב]"
    ],
      [
      "1. איפה אני קושר/ת ערך לתוצאה?\n[כאן אני כותב]",
      "2. איזו תכונה בי קיימת בלי קשר להצלחה?\n[כאן אני כותב]",
      "3. איך מרגיש להפריד?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני יותר מתוצאה."
    ],
      [
      "סגירה",
      "אני יותר מתוצאה."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב תכונה אחת בי.",
      "לכתוב תכונה אחת בי."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "לשנות שפה פנימית",
    opening: localizedGenderNode(
      [
      "היום אני מחליף/ה מילה אחת."
    ],
      [
      "היום אני מחליף/ה מילה אחת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה."
    ],
      [
      "נשימה."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. איזו מילה אלימה אני אומר/ת לעצמי?\n[כאן אני כותב]",
      "2. איך היא נשמעת בגרסה אנושית?\n[כאן אני כותב]",
      "3. איזו מילה חדשה אני בוחר/ת?\n[כאן אני כותב]"
    ],
      [
      "1. איזו מילה אלימה אני אומר/ת לעצמי?\n[כאן אני כותב]",
      "2. איך היא נשמעת בגרסה אנושית?\n[כאן אני כותב]",
      "3. איזו מילה חדשה אני בוחר/ת?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "מילים בונות מציאות."
    ],
      [
      "סגירה",
      "מילים בונות מציאות."
    ]
    ),
    action: localizedGenderNode(
      "החלפה אחת בלבד.",
      "החלפה אחת בלבד."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "כיוון במקום הוכחה",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת כיוון, לא הוכחה."
    ],
      [
      "היום אני בוחר/ת כיוון, לא הוכחה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה."
    ],
      [
      "נשימה."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. איזה ערך חשוב לי עכשיו?\n[כאן אני כותב]",
      "2. איזו פעולה קטנה משרתת אותו?\n[כאן אני כותב]",
      "3. מה אני מבטיח/ה לעצמי ביום קשה?\n[כאן אני כותב]"
    ],
      [
      "1. איזה ערך חשוב לי עכשיו?\n[כאן אני כותב]",
      "2. איזו פעולה קטנה משרתת אותו?\n[כאן אני כותב]",
      "3. מה אני מבטיח/ה לעצמי ביום קשה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "כיוון מספיק."
    ],
      [
      "סגירה",
      "כיוון מספיק."
    ]
    ),
    action: localizedGenderNode(
      "לתכנן צעד קטן.",
      "לתכנן צעד קטן."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "סגירה רכה",
    opening: localizedGenderNode(
      [
      "היום אני סוגר/ת פרק בלי למחוק את עצמי."
    ],
      [
      "היום אני סוגר/ת פרק בלי למחוק את עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה."
    ],
      [
      "נשימה."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מה השתנה ביחס שלי לכישלון?\n[כאן אני כותב]",
      "2. מה אני יודע/ת עכשיו שלא ידעתי?\n[כאן אני כותב]",
      "3. משפט חזרה לימים קשים:\n[כאן אני כותב]"
    ],
      [
      "1. מה השתנה ביחס שלי לכישלון?\n[כאן אני כותב]",
      "2. מה אני יודע/ת עכשיו שלא ידעתי?\n[כאן אני כותב]",
      "3. משפט חזרה לימים קשים:\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה סופית",
      "אני לא סכום הכישלונות שלי.",
      "אני אדם בתהליך.",
      "ואני נשאר/ת איתי.",
      "וזה כוח."
    ],
      [
      "סגירה סופית",
      "אני לא סכום הכישלונות שלי.",
      "אני אדם בתהליך.",
      "ואני נשאר/ת איתי.",
      "וזה כוח."
    ]
    ),
    action: localizedGenderNode(
      "פעולה אחת שמסמלת המשך.",
      "פעולה אחת שמסמלת המשך."
    ),
  },
].map(buildNormalizedDay);

export const chronicSenseOfFailureBlueprintHe = buildNormalizedPilotBlueprint({
  id: "chronic_sense_of_failure_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "chronic_sense_of_failure",
  category: "general",
  journeyName: {
    he: "תחושת כישלון כרונית",
    en: "Chronic Sense of Failure",
    es: "Sensación Crónica de Fracaso",
  },
  days,
});

export default chronicSenseOfFailureBlueprintHe;
